import moment from 'moment'
import Bugsnag from '../plugins/bugsnag'
import { params } from '../localData'
import mixpanel from '../plugins/mixPanel'
import {
  PhoneNumber,
  PhoneNumberFormat,
  PhoneNumberType,
  PhoneNumberUtil,
} from 'google-libphonenumber'
import { WEB_APP_URL } from '../consts'

moment.parseTwoDigitYear = function (yearString) {
  var year = parseInt(yearString)
  return (year > 22 ? 1900 : 2000) + year
}

export const getFromLocal = (keyName) => {
  return localStorage.getItem(keyName)
}
export const setToLocalStorage = ({ key, value }) => {
  return localStorage.setItem(key, value)
}

export const getLocale = () => {
  let browserLocale = window.navigator.userLanguage || window.navigator.language
  return browserLocale.split('-')[0]
}

export const getRandomiseFlowDecision = (percent) => {
  let decisionStatus
  if (Math.random() < percent / 100) {
    decisionStatus = true
  } else {
    decisionStatus = false
  }
  return decisionStatus
}
export const getRedirectUrl = () => {
  let redirectUrl = 'https://lili.onelink.me/HdRF/gotoaccount'

  if (
    window.location.href.includes('localhost') ||
    window.location.href.includes('integ')
  ) {
    redirectUrl = 'https://lili.onelink.me/HdRF/igotoaccount'
  }
  switch (process.env.NODE_ENV) {
    case 'development':
      redirectUrl = 'https://lili.onelink.me/HdRF/igotoaccount'
      break
    case 'production':
      redirectUrl = 'https://lili.onelink.me/HdRF/gotoaccount'
      break
    case 'sandbox':
      redirectUrl = 'https://lili.onelink.me/HdRF/sgotoaccount'
      break
    default:
      redirectUrl = 'https://lili.onelink.me/HdRF/gotoaccount'
      break
  }
  mixpanel.track('Onboarding Redirect', {
    URL: redirectUrl,
  })
  return redirectUrl
}
export const redirectToApp = () => {
  window.location.replace(getRedirectUrl())
}
export const setCookie = (cname, cvalue, exdays, isLiliDomain = false) => {
  var d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  var expires = 'expires=' + d.toUTCString()
  document.cookie =
    cname +
    '=' +
    cvalue +
    ';' +
    expires +
    `${isLiliDomain ? ';domain=.lili.co' : ''}` +
    ';path=/'
}

export const getCookie = (cname) => {
  var name = cname + '='
  try {
    var decodedCookie = decodeURIComponent(document.cookie)
  } catch (e) {
    return ''
  }
  var ca = decodedCookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export const isLocalStorage = () => {
  try {
    window.localStorage.setItem('storageTest', true)
    return true
  } catch (e) {
    return false
  }
}

export const uppercaseFirstLetter = (data) => {
  let value = data.charAt(0).toUpperCase() + data.slice(1)
  return value
}

export const formatDateToISO = (date) => {
  return moment.parseZone(date, 'MM/DD/YYYY').toISOString()
}

export const isFromLiliApp = () => {
  let origins = ['Lili', 'liliapp']
  let status = false
  origins.map((origin) => {
    if (navigator.userAgent.toLowerCase().includes(origin.toLowerCase())) {
      status = true
    }
  })
  return status
}

export const getDeviceType = () => {
  let type
  if (
    !!navigator.userAgent &&
    /iPad|iPhone|iPod|MacIntel/.test(navigator.userAgent)
  ) {
    type = 'ios'
  } else if (
    !!navigator.userAgent &&
    /android|Android/i.test(navigator.userAgent)
  ) {
    type = 'android'
  } else {
    type = 'unknown'
  }
  return type
}

export const hash = async (string) => {
  try {
    const utf8 = new TextEncoder().encode(string)
    const hashBuffer = await crypto.subtle.digest('SHA-256', utf8)
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    const hashHex = hashArray
      .map((bytes) => bytes.toString(16).padStart(2, '0'))
      .join('')
    return hashHex
  } catch (err) {
    Bugsnag.notify('Hash exception: ', JSON.stringify(err))
  }
}
export const decodeURI = (data, rounds) => {
  let decodeRounds = rounds
  let decodedData = data
  try {
    for (let i = 1; i <= decodeRounds; i++) {
      decodedData = decodeURIComponent(decodedData)
    }
    return decodedData
  } catch (error) {
    console.log(error)
    return data
  }
}

export const updateCustomerStep = async (
  store,
  step,
  accessToken,
  customerId
) => {
  try {
    await store.dispatch('customer/updateCustomer', {
      method: 'post',
      endPoint: `v3/secureonboarding/user/${customerId}/step`,
      data: {
        step: step,
        version: params.stepVersion,
      },
      header: {
        headerName: params.httpHeaders.auth,
        headerValue: `Bearer ${accessToken}`,
      },
    })
  } catch (error) {
    console.error('Error updating customer step:', error)
  }
}

export const isElementMultiLine = (el) => {
  const lineHeight = parseFloat(getComputedStyle(el).lineHeight)
  const elHeight = el.offsetHeight
  return elHeight > lineHeight
}

export const PhoneUtil = PhoneNumberUtil.getInstance()

export const getExamplePhoneNum = (isoCode) => {
  return formatRawPhoneNum(
    PhoneUtil.getExampleNumberForType(isoCode, PhoneNumberType.MOBILE)
  )
}

export const ensurePrefixAndFormat = (phoneNum, phonePrefix) => {
  const newCleanVal = phoneNum.startsWith(phonePrefix)
    ? phoneNum.slice(phonePrefix.length + 1)
    : phoneNum

  if (!newCleanVal.trim()) return `${phonePrefix} `
  const newVal = `${phonePrefix} ${newCleanVal}`
  return formatRawPhoneNum(newVal)
}

export const getRegionCodeForNumber = (num) => {
  try {
    const numInstance = PhoneUtil.parse(num)
    return PhoneUtil.getRegionCodeForNumber(numInstance)
  } catch (e) {
    return ''
  }
}

export const formatRawPhoneNum = (num) => {
  if (!num) return ''
  try {
    let numInstance = num instanceof PhoneNumber ? num : PhoneUtil.parse(num)
    const internationalNum = PhoneUtil.format(
      numInstance,
      PhoneNumberFormat.INTERNATIONAL
    )
    return internationalNum
  } catch (e) {
    return num
  }
}

const VALID_VALIDATION_RESULTS = [
  PhoneNumberUtil.ValidationResult.IS_POSSIBLE,
  PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY,
]

export const isValidNum = (num) => {
  try {
    const validationResult = PhoneUtil.isPossibleNumberWithReason(
      PhoneUtil.parse(num)
    )
    return VALID_VALIDATION_RESULTS.includes(validationResult)
  } catch (e) {
    return false
  }
}

export const escapeRegexChars = (str) =>
  str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

export const isEmptyValueOrSpace = (val) =>
  val === undefined || val === null || val === '' || val === ' '

export const ensureArrayValues = (arr, valToFill, numOfVals) => {
  const result = [...arr]
  const missingCount = Math.max(0, numOfVals - result.length)
  for (let i = 0; i < missingCount; i++) {
    result.push(valToFill)
  }
  return result
}

export const extractPastedData = (ev) => ev.clipboardData.getData('Text')

export const getInnerInput = (el) => el.querySelector('input') || el

export const prepareOtpArray = (value, numOfChars, fillValue = ' ') => {
  return ensureArrayValues(
    value.split('').slice(0, numOfChars),
    fillValue,
    numOfChars
  )
}

export const scheduleFocusOnInnerInput = (el, timeout = 0) => {
  setTimeout(() => {
    getInnerInput(el).focus()
  }, timeout)
}

export const focusOnInnerInput = (el) => {
  getInnerInput(el).focus()
}

export const getNextInputToFocus = (el) => {
  const sibling = el.nextSibling
  if (!sibling) return null
  return sibling
}

export const getNextEmptyInputToFocus = (el, isEmptyValueFn) => {
  const sibling = el.nextSibling
  if (!sibling) return null
  const siblingValue = getInnerInput(sibling).value
  return !isEmptyValueFn(siblingValue)
    ? getNextInputToFocus(sibling, isEmptyValueFn)
    : sibling
}

export const debounce = (func, wait = 500) => {
  let timeout

  return function (...args) {
    const context = this

    clearTimeout(timeout)

    timeout = setTimeout(() => {
      func.apply(context, args)
    }, wait)
  }
}

export const cleanNumber = (num) => num.replace(/\D/g, '')

export const cleanString = (str) => str.replace(/[^a-zA-Z0-9]/g, '')

export const redirectToWebApp = (queryParams = null) => {
  let url = new URL(window.location.href)
  let searchParams = new URLSearchParams(url.search)
  if (queryParams) {
    Object.keys(queryParams).forEach((key) => {
      searchParams.set(key, queryParams[key])
    })
  }

  const newUrl = new URL(WEB_APP_URL)
  newUrl.search = searchParams.toString()
  window.location.replace(newUrl)
}

export const isObjEmpty = (obj) => Object.keys(obj).length === 0



// WEBPACK FOOTER //
// ./src/services/UtilService.js